module.exports = function() {
  return new Worker(__webpack_public_path__ + "398e3a08a0727d24b19c.worker.js");
};